export class WebSimuladorAreaAberta {
    nome: string;
    email: string;
    cpf: string;
    dtNascimento: Date;
    dtSimulacao: Date;
    valorDesejado: number;
    valorContribuicao: number;
    depositoInicial: number;
    tempoContribuicao: number;
    tempoRecebimento: number;
    rentabilidade: number;
    valorSimulacao:number;
    abonoAnual:string
}